<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';
// const { $toast } = useNuxtApp();


const chatStore = useChatStore();
const config = useRuntimeConfig();
const props = withDefaults(defineProps<{ isOpen: boolean, isClose: boolean }>(), {
  isOpen: false,
})

const radio = ref('');
const comment = ref('');

/**
 * 評価送信
 */
const sendBadReview = async () => {

  if (!radio.value) {
    // $toast.warning('理由を選択してください')
    return
  }

  const reviewData = {} as ReviewData;
  reviewData.historyId = chatStore.sendBadReviewHistoryId;
  reviewData.comment = `[${radio.value}] ${comment.value}`;

  const result = await chatStore.sendBadReview(reviewData, false);

  if (!result) {
    console.log('評価の送信が失敗しました');
    // $toast.error('評価の送信が失敗しました');
  }
  else {
    console.log('評価の送信が完了しました');
    // $toast.default('評価の送信が完了しました');
  }

  closeModal();
};

/**
 * モーダルを閉じる
 */
const closeModal = () => {
  radio.value = '';
  comment.value = ''
  // chatStore.reviewBtn = ''
  chatStore.reviewModal = false;
};
</script>

<template>
  <ClientOnly>
    <div v-if="props.isOpen">
      <div class="fixed inset-0 bg-black/40 z-40" aria-hidden="true"></div>
      <div class="fixed inset-0 flex justify-center items-center z-50">
        <div class="bg-white p-5 rounded-lg w-[300px]">
          <div class="flex justify-end">
            <button type="button" @click="closeModal()" aria-label="入力画面モーダルを閉じる">
              <Icon name="material-symbols:cancel-outline" size="20px" />
            </button>
          </div>

          <div>
            <div class="flex items-center">
              <Icon name="material-symbols:chat-outline" color="#707070" size="18px" />
              <p class="font-bold text-base tracking-[1.4px] pl-2">{{ $t('badModalTitle') }}</p>
            </div>
            <div class="pt-5 flex flex-wrap tracking-[1.5px] w-[250px] text-sm gap-1">
              <label class="radio-button" v-for="hyoka in $tm('hyokaKoumokus')" :key="hyoka.value">
                <input type="radio" name="option" class="hidden" v-model="radio" :value="hyoka.value">
                <span class="btn">{{ hyoka.text }}</span>
              </label>
            </div>

            <div class="pt-5">
              <textarea id="reason"
                class="w-full resize-none h-[100px] border border-solid border-design-gray rounded-sm text-base p-2 placeholder:text-design-gray outline outline-none"
                type="textarea" name="reason" :placeholder="$t('badReasonPlaceholder')" v-model="comment"></textarea>
            </div>

            <p v-if="radio.length + comment.length < 0" class="text-xs text-design-red text-center">理由を選択または入力してください</p>

            <div class="pt-2 flex justify-end gap-2">
              <button type="button" :disabled="radio == ''"
                class="rounded-2xl bg-design-red text-white text-base px-5 py-1" @click="sendBadReview">{{ $t('send')
                }}</button>
              <button type="button" class="rounded-2xl border border-[#C3C3C3] text-design-gray text-sm px-5 py-1"
                @click="closeModal()">{{ $t('cancel') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<style scoped>
@reference "../assets/css/tailwind.css";

button:disabled {
  opacity: 0.5;
}

input[type='radio'] {
  accent-color: #D53939;
}

.radio-button input:checked+.btn {
  @apply bg-[#D53939];
  @apply text-white;
}

.radio-button .btn {
  @apply inline-block px-4 py-2 bg-gray-200 text-gray-700 rounded cursor-pointer;
}

.radio-button input:focus+.btn {
  @apply ring-2 ring-[#D53939];
}
</style>
